import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string } from 'prop-types';
import { Label } from './hidden-label.styles';

const HiddenLabel = _ref => {
  let {
    text
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["text"]);

  return /*#__PURE__*/React.createElement(Label, props, text);
};

HiddenLabel.defaultProps = {
  text: ''
};
process.env.NODE_ENV !== "production" ? HiddenLabel.propTypes = {
  text: string
} : void 0;
export default HiddenLabel;